import { defineStore } from 'pinia';
import { HttpStatusCode } from 'axios';
import { http } from '@/http';
import { useNotification } from '@kyvg/vue3-notification';

const baseUrl = `/api/v1`;
const { notify } = useNotification();

export const useHttpStore = defineStore('http',()=>{
    const upload = async (url, image)=>{
        try {
            const data = new FormData();
            data.append('image', image);

            let config = {
                header : {
                    'Content-Type' : 'multipart/form-data'
                },
                onUploadProgress: (progress)=>{
                    console.log(`on progress ${progress}`,progress);
                }
            };
            const resp = await http.post(url,data, config)
            console.log('httpStore.upload ', resp)
            if ((resp.status == HttpStatusCode.Ok || resp.status == HttpStatusCode.Created)) {
                return true;
            } else {
                return false;
            }

        } catch (err) {
            let text = err;
            if (err.code = HttpStatusCode.BadRequest) err = err.response.data.reason;
            if (err.reason) err = err.reason;
            notify({
                title: 'Загрузка файла ',
                text: err,
                type: 'error'
            });
            console.error(`httpStore.upload ${err}`);
            return false;
        }
    }

    const get = async(url)=>{
        const fullurl = `${baseUrl}/${url}`;
        try {
            let resp = await http.get(fullurl);
            if (resp.status == HttpStatusCode.Ok) {
                console.log(`httpStore.get(${fullurl})resp`,resp);
                return resp.data;
            } else {
                return null;
            }
        } catch (err) {
            notify({
                text: err,
                type: 'error'
            });
            console.error(`httpStore get (${fullurl}) ${err}`);
        }
    }

    const post = async(url,data,config=null)=> {
        const fullurl = `${baseUrl}/${url}`;
        let res=null;
        try {
            let resp = await http.post(fullurl,data,config);
            if (resp.status == HttpStatusCode.Ok) {
                console.log(`httpStore.post(${fullurl})resp`,resp);
                res = resp.data ? resp.data : resp;
            }
        } catch (err) {
            const errtext = err.response.data.reason?err.response.data.reason:err;
            notify({
                text: errtext,
                type: 'error'
            });
            console.error(`httpStore post (${fullurl}) ${err}`);
        } finally {
            return res;
        }
    }

    const patch = async(url,data,config=null)=> {
        const fullurl = `${baseUrl}/${url}`;
        let res = null;
        try {
            let resp = await http.patch(fullurl,data,config);
            if (resp.status == HttpStatusCode.Ok) {
                console.log(`httpStore.patch(${fullurl})resp`,resp);
                res = resp.data;
            }
        } catch (err) {
            notify({
                text: err,
                type: 'error'
            });
            console.error(`httpStore patch (${fullurl}) ${err}`);
            res = null;
        } finally {
            return res;
        }
    }

    const put = async(url,data,config=null)=> {
        const fullurl = `${baseUrl}/${url}`;
        let res = null;
        try {
            let resp = await http.put(fullurl,data,config);
            if (resp.status == HttpStatusCode.Ok) {
                console.log(`httpStore.put(${fullurl})resp`,resp);
                res = resp.data;
            }
        } catch (err) {
            notify({
                text: err,
                type: 'error'
            });
            console.error(`httpStore put (${fullurl}) ${err}`);
            res = null;
        } finally {
            return res;
        }
    }

    const del = async(url)=>{
        const fullurl = `${baseUrl}/${url}`;
        let res = null;
        try {
            let resp = await http.delete(fullurl);
            if (resp.status == HttpStatusCode.Ok || resp.status == HttpStatusCode.NoContent) {
                console.log(`httpStore.delete(${fullurl})resp`,resp);
                res = resp.data ? resp.data : resp;
            }
        } catch (err) {
            notify({
                text: err,
                type: 'error'
            });
            console.error(`httpStore delete (${fullurl}) ${err}`);
            res = null;
        } finally {
            return res;
        }
    }

    return { post, get, upload, patch, put, del };
});
